export const OVER_18_DENMARK_FLOW = 'over18Denmark';
export const OVER_18_FOREIGN_FLOW = 'over18Foreign';
export const UNDER_18_DENMARK_FLOW = 'under18Denmark';

export type Flow = typeof OVER_18_DENMARK_FLOW | typeof OVER_18_FOREIGN_FLOW | typeof UNDER_18_DENMARK_FLOW;

const DANISH_FLOW_COUNTRY_CODES = new Set(['DK', 'GL']);

export const isDanishFlowCountry = (countryCode: string): boolean => {
  return DANISH_FLOW_COUNTRY_CODES.has(countryCode);
};

export const resolveFlow = (countryCode: string): Flow => {
  return isDanishFlowCountry(countryCode) ? OVER_18_DENMARK_FLOW : OVER_18_FOREIGN_FLOW;
};
